var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-hbl" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  { staticClass: "operat-wrap" },
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: {
                          no: "command1",
                          "split-button": "",
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyCargoDescriptionAndMarks"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyCargoDescriptionAndMarks"
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { command: _vm.$t("SeaExport.CopyMbl") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.CopyMbl")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "originalPrint",
                          disabled: _vm.btnPrintDisabled,
                          type: "primary"
                        },
                        on: { click: _vm.originalPrint }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.releaseType === 1
                              ? _vm.$t("SeaExport.PrintTheOriginalBl")
                              : _vm.$t("SeaExport.TelexRelease")
                          ) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.state === 2,
                            expression: "form.state===2"
                          }
                        ],
                        attrs: {
                          disabled: !(
                            _vm.form.state === 2 &&
                            this.$checkPermission(["button_M/HBL_unlock"])
                          ),
                          no: "Unlock",
                          type: "primary"
                        },
                        on: { click: _vm.unlock }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "showAddressFormatDialog",
                          disabled: _vm.readonly || !_vm.form.uuid,
                          type: "primary"
                        },
                        on: { click: _vm.showAddressFormatDialog }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.AntiTerroristFormattedAddress")
                          )
                        )
                      ]
                    ),
                    !_vm.OpenXHQDocumentCenter
                      ? _c(
                          "el-dropdown",
                          {
                            class: _vm.btnBLConfirmDisabled ? "not-click" : "",
                            staticStyle: { "padding-left": "5px" },
                            attrs: {
                              no: "command2",
                              "split-button": "",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.commandHandle(_vm.command2)
                              },
                              command: function(p) {
                                _vm.command2 = p
                                _vm.commandHandle(_vm.command2)
                              }
                            }
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.command2) + " "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.InviteToChecktheBL"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["button_M/HBL_confirmBL"],
                                        expression: "['button_M/HBL_confirmBL']"
                                      }
                                    ],
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.ConfirmChecking"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ConfirmChecking")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["button_M/HBL_identification"],
                                        expression:
                                          "['button_M/HBL_identification']"
                                      }
                                    ],
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.IdentificationList"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.IdentificationList")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.CheckingHistory"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CheckingHistory")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: _vm.$t(
                                        "SeaExport.UploadGuarantee"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.UploadGuarantee")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter &&
                    (_vm.job.typeHBL === 0 || _vm.job.typeHBL === 1)
                      ? _c(
                          "el-menu",
                          {
                            staticClass:
                              "el-menu-button el-button el-button--primary el-button--mini",
                            class: _vm.isEdit ? "is-disabled not-click" : "",
                            staticStyle: { "vertical-align": "top" },
                            attrs: {
                              "text-color": "#404144",
                              "active-text-color": "#404144",
                              mode: "horizontal"
                            },
                            on: { select: _vm.XHQDocumentCenterSelectHandler }
                          },
                          [
                            _c(
                              "el-submenu",
                              { attrs: { index: "index" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-menu-btn-text",
                                    attrs: { slot: "title" },
                                    slot: "title"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "InviteToChecktheBL" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.InviteToChecktheBL")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-submenu",
                                  {
                                    attrs: {
                                      index: _vm.$t(
                                        "SeaExport.UploadCustomerFiles"
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.UploadCustomerFiles"
                                          )
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index:
                                            "BillOfLadingConfirmationDocument"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Clearing.BillOfLadingConfirmationDocument"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          index: "CustomerSelfIssuedFiles"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CustomerSelfIssuedFiles"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm.ToExoSystemJYD
                                      ? _c(
                                          "el-menu-item",
                                          {
                                            attrs: {
                                              index: "OriginBillOfLading"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.OriginBillOfLading"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { index: "ShippingOrder" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ShippingOrder")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "CheckTheBLLog" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.CheckTheBLLog"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "ConfirmChecking" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ConfirmChecking")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "UploadGuarantee" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.UploadGuarantee")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter &&
                    this.$checkPermission(["button_M/HBL_identification"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit,
                              no: "IdentificationList",
                              type: "primary"
                            },
                            on: { click: _vm.onIdentificationList }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.IdentificationList"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.ToExoSystemJYD &&
                    (_vm.job.typeHBL === 0 || _vm.job.typeHBL === 1)
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit,
                              no: "CustomerToOrder",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onOpenDocLink(0)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerToOrder")))]
                        )
                      : _vm._e(),
                    _vm.ToExoSystemJYD &&
                    (_vm.job.typeHBL === 0 || _vm.job.typeHBL === 1)
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit,
                              no: "DesignatedGoodsToBillOfLading",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onOpenDocLink(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.DesignatedGoodsToBillOfLading"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.OpenXHQDocumentCenter &&
                    (_vm.job.typeHBL === 0 || _vm.job.typeHBL === 1)
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: _vm.isEdit,
                              no: "updateBillInfo",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.updateBillInfo()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ConfirmationBillOfLading")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.viewSource === "SeBooking"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_insurance_toInsure"],
                                expression: "['button_insurance_toInsure']"
                              }
                            ],
                            attrs: {
                              no: "Insure",
                              disabled: _vm.isEdit,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.toInsure()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-menu",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_EDI_overseasAgentForecast"],
                            expression: "['button_EDI_overseasAgentForecast']"
                          }
                        ],
                        staticClass:
                          "el-menu-button el-button el-button--primary el-button--mini",
                        class: _vm.isEdit ? "is-disabled not-click" : "",
                        style: {
                          width: "auto",
                          minWidth: _vm.$selectByLang(
                            "100px",
                            "100px",
                            "100px",
                            "120px",
                            "120px",
                            "120px"
                          ),
                          verticalAlign: "top"
                        },
                        attrs: {
                          "text-color": "#404144",
                          "active-text-color": "#404144",
                          mode: "horizontal"
                        },
                        on: { select: _vm.toOverseaAgeFore }
                      },
                      [
                        _c(
                          "el-submenu",
                          { attrs: { index: "index" } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "el-menu-btn-text",
                                attrs: { slot: "title" },
                                slot: "title"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.OverseasAgeFore"))
                                )
                              ]
                            ),
                            _c(
                              "el-menu-item",
                              {
                                attrs: { index: _vm.$t("SeaExport.Original") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Original")))]
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { index: _vm.$t("SeaExport.Correct") } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Correct")))]
                            ),
                            _c(
                              "el-menu-item",
                              {
                                attrs: {
                                  index: _vm.$t("CargoMsg.Cargo_Delete")
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { value: _vm.form.state === 2, disabled: true }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Locked")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "oversea", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.BlBeReleasedElsewhereOrNot"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "manifestEDI", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.manifestEDI,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "manifestEDI", $$v)
                          },
                          expression: "form.manifestEDI"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ManifestEdi")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "printParam1", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam1", $$v)
                          },
                          expression: "form.printParam1"
                        }
                      },
                      [_vm._v("Part of")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "printParam2", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam2", $$v)
                          },
                          expression: "form.printParam2"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ClauseOfNoWoodPackingMaterial")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { no: "printParam3", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam3", $$v)
                          },
                          expression: "form.printParam3"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "chkConsolidationClosed",
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.chkConsolidationClosed,
                          callback: function($$v) {
                            _vm.chkConsolidationClosed = $$v
                          },
                          expression: "chkConsolidationClosed"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AFRTheLastBill")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.barge,
                            expression: "job.barge"
                          }
                        ],
                        attrs: { no: "printParam6", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam6,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam6", $$v)
                          },
                          expression: "form.printParam6"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PrintBargeVesselAndVoyage"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "customerSelfRelease",
                          value: _vm.form.customerSelfRelease === 1,
                          disabled: _vm.readonly
                        },
                        on: { input: _vm.isCustomerSelfRelease }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerSelfRelease")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "customerSelfRelease2",
                          value: _vm.form.customerSelfRelease === 2,
                          disabled: _vm.readonly
                        },
                        on: { input: _vm.isCompanySelfRelease }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CompanySelfRelease")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "label-width": "70px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                          )
                        )
                      ]),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          {
                            class: _vm.variableCss.shipperLine,
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "shipperCode",
                              class: _vm.importDifferenceField.shipperCode
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "shipperCode"
                              },
                              model: {
                                value: _vm.form.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperCode", $$v)
                                },
                                expression: "form.shipperCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              class: _vm.importDifferenceField.shipperId
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "shipperId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                headers: [_vm.$t("Partners.englishName")],
                                fields: ["englishName"],
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                filterable: "",
                                "default-value": _vm.form.shipperId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.shipperAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "6px" },
                                attrs: {
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c("char-count", {
                              attrs: {
                                inline: "",
                                form: _vm.form,
                                prefix: "shipper"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "shipperLine" + count,
                            class:
                              "auto-width " + _vm.getClass("shipperLine", count)
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck["shipperLine" + count]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "shipperLine" + count,
                                  refInFor: true,
                                  class: _vm.importDifferenceField[
                                    "shipperLine" + count
                                  ]
                                    ? "red-border"
                                    : "",
                                  attrs: {
                                    disabled: _vm.readonly,
                                    no: "shipperLine" + count,
                                    placeholder: _vm.placeholderSFT(count),
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "filter-chars": false,
                                    "use-read-only": true
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "shipperLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "shipperLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showShipperDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["shipperLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "shipperLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['shipperLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          {
                            class: _vm.variableCss.consigneeLine,
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "consigneeCode",
                              class: _vm.importDifferenceField.consigneeCode
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeCode"
                              },
                              model: {
                                value: _vm.form.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeCode", $$v)
                                },
                                expression: "form.consigneeCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              class: _vm.importDifferenceField.consigneeId
                                ? "red-border"
                                : "",
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                headers: [_vm.$t("Partners.englishName")],
                                fields: ["englishName"],
                                "method-params": {
                                  consignee: true,
                                  active: true
                                },
                                filterable: "",
                                "default-value": _vm.form.consigneeId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.consigneeAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "6px" },
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(2)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c("char-count", {
                              attrs: {
                                inline: "",
                                form: _vm.form,
                                prefix: "consignee"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "consigneeLine" + count,
                            class:
                              "auto-width " +
                              _vm.getClass("consigneeLine", count),
                            model: {
                              value: _vm.form["consigneeLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + count, $$v)
                              },
                              expression: "form['consigneeLine'+count]"
                            }
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck[
                                      "consigneeLine" + count
                                    ]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "consigneeLine" + count,
                                  refInFor: true,
                                  class: _vm.importDifferenceField[
                                    "consigneeLine" + count
                                  ]
                                    ? "red-border"
                                    : "",
                                  attrs: {
                                    disabled: _vm.readonly,
                                    no: "consigneeLine" + count,
                                    placeholder: _vm.placeholderSFT(count),
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "use-read-only": true,
                                    "filter-chars": false
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "consigneeLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "consigneeLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showConsigneeDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["consigneeLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['consigneeLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          {
                            class: _vm.variableCss.notifyLine,
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))]
                        ),
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              ref: "notifyCode",
                              class: _vm.importDifferenceField.notifyCode
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyCode"
                              },
                              model: {
                                value: _vm.form.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyCode", $$v)
                                },
                                expression: "form.notifyCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                  expression:
                                    "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                }
                              ],
                              class: _vm.importDifferenceField.notifyId
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                headers: [_vm.$t("Partners.englishName")],
                                fields: ["englishName"],
                                "method-params": { notify: true, active: true },
                                filterable: "",
                                "default-value": _vm.form.notifyId || "",
                                "tag-name": "englishName"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.notifyAutoCompleteChange(p)
                                }
                              }
                            }),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "Reset",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(3)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "CopyTheConsignee",
                                      type: "primary",
                                      disabled: _vm.readonly
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onCopy_consignee()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CopyTheConsignee")
                                      )
                                    )
                                  ]
                                ),
                                _c("char-count", {
                                  attrs: {
                                    inline: "",
                                    form: _vm.form,
                                    prefix: "notify"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "notifyLine" + count,
                            class:
                              "auto-width " + _vm.getClass("notifyLine", count)
                          },
                          [
                            _c(
                              "special-character-tip",
                              {
                                attrs: {
                                  texts:
                                    _vm.specialCharCheck["notifyLine" + count]
                                }
                              },
                              [
                                _c("cargo-input", {
                                  ref: "notifyLine" + count,
                                  refInFor: true,
                                  class: _vm.importDifferenceField[
                                    "notifyLine" + count
                                  ]
                                    ? "red-border"
                                    : "",
                                  attrs: {
                                    disabled: _vm.readonly,
                                    no: "notifyLine" + count,
                                    placeholder: _vm.placeholderSFT(count),
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify,
                                    "use-read-only": true,
                                    "filter-chars": false
                                  },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "notifyLine" + count,
                                        count + 1 > 6
                                          ? null
                                          : "notifyLine" + (count + 1),
                                        _vm.maxChars
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      return _vm.showNotifyDialog($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form["notifyLine" + count],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "notifyLine" + count,
                                        $$v
                                      )
                                    },
                                    expression: "form['notifyLine'+count]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c(
                          "span",
                          {
                            class: _vm.variableCss.agentPartyLine,
                            style: _vm.variableCss.agentPartyLine
                              ? ""
                              : "color:#404144!important;",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AgentInfo")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "min-width": "50px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "onClear4",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(4)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c(
                              "el-dropdown",
                              {
                                class: _vm.readonly ? "not-click" : "",
                                attrs: {
                                  no: "command3",
                                  "split-button": "",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.commandHandle(_vm.command3)
                                  },
                                  command: function(p) {
                                    _vm.command3 = p
                                    _vm.commandHandle(_vm.command3)
                                  }
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.command3) + " "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.CopyMblConsignee"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.CopyMblConsignee")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "SeaExport.CopyNominatedAgentInfo"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.CopyNominatedAgentInfo"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._l(7, function(count) {
                        return _c(
                          "el-form-item",
                          {
                            key: "agentPartyLine" + count,
                            class:
                              "auto-width " +
                              _vm.getClass("agentPartyLine", count)
                          },
                          [
                            _c("cargo-input", {
                              ref: "agentPartyLine" + count,
                              refInFor: true,
                              attrs: {
                                disabled: _vm.readonly,
                                no: "agentPartyLine" + count,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true,
                                "filter-chars": false
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "agentPartyLine" + count,
                                    count + 1 > 6
                                      ? null
                                      : "agentPartyLine" + (count + 1),
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAgentPartyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form["agentPartyLine" + count],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "agentPartyLine" + count,
                                    $$v
                                  )
                                },
                                expression: "form['agentPartyLine'+count]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("span", { staticStyle: { color: "#404144" } }, [
                          _vm._v("ALSO NOTIFY")
                        ])
                      ]),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "alsoNotify",
                              "text-chars": 0,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAdvanceTextDialog(
                                  "ALSO NOTIFY",
                                  _vm.form.alsoNotify,
                                  function(val) {
                                    _vm.form.alsoNotify = val
                                  },
                                  _vm.notUppercaseShipperConsigneNotify,
                                  {
                                    warningCount: 45,
                                    autoUppercase:
                                      _vm.notUppercaseShipperConsigneNotify,
                                    autoHalfWord: true
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.alsoNotify,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "alsoNotify", $$v)
                              },
                              expression: "form.alsoNotify"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "125px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.quantity,
                          attrs: {
                            label: _vm.$t("SeaExport.NumberOfPackagesOnBl")
                          }
                        },
                        [
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.quantity
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "quantity",
                              precision: 0,
                              min: 0,
                              disabled: !_vm.isJydEditJobFields
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.quantity_Change()
                              }
                            },
                            model: {
                              value: _vm.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantity", $$v)
                              },
                              expression: "form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.packing,
                          attrs: { label: _vm.$t("SeaExport.Package") }
                        },
                        [
                          _c("cargo-packing-select", {
                            class: _vm.importDifferenceField.packing
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "packing",
                              "default-value": _vm.form.packing
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.packing_Change(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PackageDisplayName")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.packingName
                              ? "red-border"
                              : "",
                            attrs: { no: "packingName" },
                            model: {
                              value: _vm.form.packingName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "packingName", $$v)
                              },
                              expression: "form.packingName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insideQuantity,
                          attrs: { label: _vm.$t("SeaExport.Pieces2") }
                        },
                        [
                          _c("auto-number-input", {
                            class: _vm.importDifferenceField.insideQuantity
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "insideQuantity",
                              precision: 0,
                              min: 0
                            },
                            model: {
                              value: _vm.job.insideQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "insideQuantity", $$v)
                              },
                              expression: "job.insideQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.insidePacking,
                          attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                        },
                        [
                          _c("cargo-packing-select", {
                            class: _vm.importDifferenceField.insidePacking
                              ? "red-border"
                              : "",
                            attrs: {
                              "default-value": _vm.form.insidePacking,
                              no: "insidePacking"
                            },
                            on: {
                              change: function(p) {
                                _vm.form.insidePacking = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.weight,
                          attrs: { label: _vm.$t("SeaExport.Weight") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly
                                ? "input-disabled"
                                : _vm.importDifferenceField.weight
                                ? "red-border"
                                : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "weight",
                                  disabled:
                                    !_vm.pm.isCanEditQwc ||
                                    !_vm.isJydEditJobFields,
                                  precision: 3,
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.changeBillOfLadingSynJob(true)
                                    _vm.pm.calculateChargeWeight()
                                  }
                                },
                                model: {
                                  value: _vm.form.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "weight", $$v)
                                  },
                                  expression: "form.weight"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.cubage,
                          attrs: { label: _vm.$t("SeaExport.Cubage") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly
                                ? "input-disabled"
                                : _vm.importDifferenceField.cubage
                                ? "red-border"
                                : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "cubage",
                                  disabled:
                                    !_vm.pm.isCanEditQwc ||
                                    !_vm.isJydEditJobFields,
                                  precision: 3,
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.changeBillOfLadingSynJob(true)
                                    _vm.pm.calculateChargeWeight()
                                  }
                                },
                                model: {
                                  value: _vm.form.cubage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cubage", $$v)
                                  },
                                  expression: "form.cubage"
                                }
                              }),
                              _c("span", [_vm._v("CBM")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-item-input",
                              class: _vm.readonly
                                ? "input-disabled"
                                : _vm.importDifferenceField.chargeWeight
                                ? "red-border"
                                : ""
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.changeBillOfLadingSynJob(
                                      false
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chargeWeight", $$v)
                                  },
                                  expression: "form.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          class: _vm.variableCss.cargoEnglishName,
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: { float: "right" },
                              attrs: { no: "getMBLInfoEName", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getMBLInfo("EName")
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyEnglishDescriptionOfGoodsFromMbl"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class:
                            "auto-width " + _vm.variableCss.cargoEnglishName,
                          attrs: {
                            label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                          }
                        },
                        [
                          _c(
                            "special-character-tip",
                            {
                              attrs: {
                                texts: _vm.specialCharCheck.cargoEnglishName
                              }
                            },
                            [
                              _c("cargo-rich-textarea", {
                                ref: "cargoTextarea1",
                                class: _vm.importDifferenceField
                                  .cargoEnglishName
                                  ? "red-border"
                                  : "",
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "cargoEnglishName",
                                  "show-count": true,
                                  "text-chars": _vm.englishNameMaxChars,
                                  "warning-count": _vm.englishNameWarningCount,
                                  "wrap-symbol": "r",
                                  disabled: !_vm.isEdit,
                                  "auto-uppercase": _vm.isUppercaseByConfig,
                                  "auto-half-word": ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.syncAms("cargoEnglishName")
                                    _vm.pm.cargoEnglishNameBlurHandler()
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t(
                                        "SeaExport.EnglishDescriptionOfGoods"
                                      ),
                                      _vm.form.cargoEnglishName,
                                      function(val) {
                                        _vm.form.cargoEnglishName = val
                                        _vm.syncAms("cargoEnglishName")
                                      },
                                      _vm.isUppercaseByConfig,
                                      {
                                        autoHalfWord: true,
                                        autoUppercase: _vm.isUppercaseByConfig,
                                        warningCount:
                                          _vm.englishNameWarningCount,
                                        maxChar: _vm.englishNameMaxChars
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                  },
                                  expression: "form.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          class: _vm.variableCss.mark,
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: {
                                float: "right",
                                "margin-left": "5px"
                              },
                              attrs: { no: "getMBLInfoMark", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getMBLInfo("mark")
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("SeaExport.CopyMarksFromMbl")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: "auto-width " + _vm.variableCss.mark,
                          attrs: { label: _vm.$t("SeaExport.Marks") }
                        },
                        [
                          _c(
                            "special-character-tip",
                            { attrs: { texts: _vm.specialCharCheck.mark } },
                            [
                              _c("cargo-rich-textarea", {
                                ref: "cargoTextarea2",
                                class: _vm.importDifferenceField.mark
                                  ? "red-border"
                                  : "",
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "mark",
                                  "show-count": true,
                                  "text-chars": _vm.markMaxChars,
                                  "warning-count": _vm.markWarningCount,
                                  "wrap-symbol": "r",
                                  disabled: !_vm.isEdit,
                                  "auto-uppercase": _vm.isUppercaseByConfig,
                                  "auto-half-word": ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.markBlurHandler()
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Marks"),
                                      _vm.form.mark,
                                      function(val) {
                                        _vm.form.mark = val
                                      },
                                      _vm.isUppercaseByConfig,
                                      {
                                        autoHalfWord: true,
                                        autoUppercase: _vm.isUppercaseByConfig,
                                        warningCount: _vm.markWarningCount,
                                        maxChar: _vm.markMaxChars
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mark", $$v)
                                  },
                                  expression: "form.mark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.CapitalizedNumbersOfPackages"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.quantitySum
                              ? "red-border"
                              : "",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.quantitySum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantitySum", $$v)
                              },
                              expression: "form.quantitySum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "HB/L NO." } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "hblNbr2",
                              disabled: _vm.hblNoDisabled || _vm.readonly
                            },
                            model: {
                              value: _vm.form.hblNbr2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hblNbr2", $$v)
                              },
                              expression: "form.hblNbr2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.soNoTitle,
                          attrs: { label: "SO NO." }
                        },
                        [
                          _c("el-input", {
                            class: _vm.variableCss.soNo,
                            attrs: {
                              value: _vm.job.soNo.replace(/\n/g, ","),
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.HBLBillOfLadingNum")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.serialNo
                              ? "red-border"
                              : "",
                            attrs: { no: "serialNo", disabled: _vm.readonly },
                            model: {
                              value: _vm.form.serialNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "serialNo", $$v)
                              },
                              expression: "form.serialNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.vesselTitle,
                          attrs: { label: _vm.$t("SeaExport.Vessel") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "vessel",
                              disabled:
                                _vm.readonly || !_vm.pm._lclslaveEnabled,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Vessel,
                              filterable: "",
                              "allow-create": _vm.pm._allowEditingVessel,
                              "default-value": _vm.job.vessel,
                              cache: false,
                              "static-options": _vm.pm.vesselList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.onVesselSelectionChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.voyageFlightTitle,
                          attrs: { label: _vm.$t("SeaExport.Voyage") }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "voyageFlight",
                            attrs: {
                              no: "voyageFlight",
                              "static-options": _vm.pm._voyages || [],
                              cache: false,
                              "default-value": _vm.job.voyageFlight,
                              disabled:
                                _vm.readonly || !_vm.pm._lclslaveEnabled,
                              filterable: "",
                              clearable: "",
                              "allow-create": _vm.pm.editVoyageMode === 1,
                              "tag-name": "voyageNo",
                              "tag-value": "voyageNo",
                              "filter-tag-names": ["voyageNo"]
                            },
                            on: {
                              focus: function($event) {
                                return _vm.pm.txtVoyageFocusInHandler()
                              },
                              parentCallBack: function(p) {
                                _vm.pm.onVoyagaFlightChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture") }
                        },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.sailingDate, disabled: true }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dispatchingPlace,
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfReceiptOnBl")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField
                              .dispatchingPlaceCode
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.dispatchingPlaceCode || "",
                              "tag-name": "englishName",
                              no: "serialNo"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "dispatchingPlace")
                              }
                            }
                          }),
                          _c("el-input", {
                            class: _vm.importDifferenceField.dispatchingPlace
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              no: "dispatchingPlace"
                            },
                            model: {
                              value: _vm.form.dispatchingPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dispatchingPlace", $$v)
                              },
                              expression: "form.dispatchingPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.loadingPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfLoadingOnBl")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.loadingPortCode
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.loadingPortCode || "",
                              "tag-name": "englishName",
                              no: "loadingPortCode"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "loadingPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            class: _vm.importDifferenceField.loadingPort
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              no: "loadingPort"
                            },
                            model: {
                              value: _vm.form.loadingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "loadingPort", $$v)
                              },
                              expression: "form.loadingPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.dischargingPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDischargeOnBl")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.dischargingPortCode
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.dischargingPortCode || "",
                              "tag-name": "englishName",
                              no: "dischargingPortCode"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "dischargingPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            class: _vm.importDifferenceField.dischargingPort
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              no: "dischargingPort"
                            },
                            model: {
                              value: _vm.form.dischargingPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dischargingPort", $$v)
                              },
                              expression: "form.dischargingPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.destinationPort,
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.destinationPortCode
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value":
                                _vm.form.destinationPortCode || "",
                              "tag-name": "englishName",
                              no: "destinationPortCode"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.portChange(p, "destinationPort")
                              }
                            }
                          }),
                          _c("el-input", {
                            class: _vm.importDifferenceField.destinationPort
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              no: "destinationPort"
                            },
                            model: {
                              value: _vm.form.destinationPort,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPort", $$v)
                              },
                              expression: "form.destinationPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BlFinalDestination")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.destinationPlace
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              "filter-chars": false,
                              no: "destinationPlace"
                            },
                            model: {
                              value: _vm.form.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destinationPlace", $$v)
                              },
                              expression: "form.destinationPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.MethodOfHblPayment")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "paymentTermHBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value": _vm.job.paymentTermHBL,
                              "allow-create": true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.paymentSelectHblChange(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PlaceOfHblPayment2")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.paymentPlaceBL
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "paymentPlaceBL"
                            },
                            model: {
                              value: _vm.form.paymentPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "paymentPlaceBL", $$v)
                              },
                              expression: "form.paymentPlaceBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.TransportationClause")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "freightTermHBL"
                            },
                            model: {
                              value: _vm.job.freightTermHBL,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "freightTermHBL", $$v)
                              },
                              expression: "job.freightTermHBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.BLNumber,
                          attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.blNumber
                              ? "red-border"
                              : "",
                            attrs: { disabled: _vm.readonly, no: "blNumber" },
                            model: {
                              value: _vm.form.blNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "blNumber", $$v)
                              },
                              expression: "form.blNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.signPlaceBL
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "signPlaceBL"
                            },
                            model: {
                              value: _vm.form.signPlaceBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signPlaceBL", $$v)
                              },
                              expression: "form.signPlaceBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                        [
                          _c("el-date-picker", {
                            class: _vm.importDifferenceField.signDateBL
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "signDateBL",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.signDateBL,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signDateBL", $$v)
                              },
                              expression: "form.signDateBL"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.variableCss.remarks,
                          attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                        },
                        [
                          _c("cargo-input", {
                            class: _vm.importDifferenceField.remarks
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "remarks",
                              type: "textarea",
                              rows: 5,
                              "filter-chars": false,
                              "use-read-only": true
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.BlRemarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                        [
                          _vm.syncHblHsCodeEdit
                            ? _c("el-input", {
                                class: _vm.importDifferenceField.hsCode
                                  ? "red-border"
                                  : "",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "hsCode",
                                  type: "textarea",
                                  rows: 5
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.HsCode"),
                                      _vm.form.hsCode,
                                      function(val) {
                                        _vm.form.hsCode = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.hsCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hsCode", $$v)
                                  },
                                  expression: "form.hsCode"
                                }
                              })
                            : _c("el-input", {
                                class: _vm.importDifferenceField.hsCode
                                  ? "red-border"
                                  : "",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "hsCode",
                                  type: "textarea",
                                  rows: 5
                                },
                                on: {
                                  input: function(val) {
                                    _vm.hsCodeChangeHandle(val)
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.HsCode"),
                                      _vm.job.hsCode,
                                      function(val) {
                                        _vm.hsCodeChangeHandle(val)
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.hsCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "hsCode", $$v)
                                  },
                                  expression: "job.hsCode"
                                }
                              })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CheckingQuestions")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField
                              .customerCfmException
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "customerCfmException",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.CheckingQuestions"),
                                  _vm.form.customerCfmException,
                                  function(val) {
                                    _vm.form.customerCfmException = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerCfmException,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerCfmException", $$v)
                              },
                              expression: "form.customerCfmException"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "label-width": "108px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlType") } },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.releaseType
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "releaseType"
                              },
                              on: {
                                change: function(val) {
                                  _vm.pm.cmbreleaseTypeMBL_changeHandler(val)
                                }
                              },
                              model: {
                                value: _vm.form.releaseType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "releaseType", $$v)
                                },
                                expression: "form.releaseType"
                              }
                            },
                            _vm._l(_vm.blModeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.name,
                                  value: item.serialNumber
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlType2") } },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.issuerBL
                              ? "red-border"
                              : "",
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "issuerBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_OrderFormType,
                              filterable: "",
                              "default-value": _vm.form.issuerBL,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              clearable: false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cmbissuerHBL_changeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BlProperty") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                value: _vm.job.typeHBL || 1,
                                no: "typeHBL",
                                disabled:
                                  _vm.cmbtypeHBLDisabled || _vm.readonly,
                                clearable: false
                              },
                              on: {
                                input: function(val) {
                                  _vm.pm.cmbtypeHBLChangeHandler(val)
                                }
                              }
                            },
                            _vm._l(_vm.BILL_TYPES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.job.jointMasterHBLUuid,
                              expression: "job.jointMasterHBLUuid"
                            }
                          ],
                          attrs: { label: _vm.$t("SeaExport.HBLHBR") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.job.jointMasterHBL
                                ? _vm.job.jointMasterHBL.jobNo
                                : "",
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { label: _vm.$t("SeaExport.CheckingStatus") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  value: _vm.lblCfrState,
                                  disabled: true
                                }
                              }),
                              _vm.showXhqOverseasAgentFeedbackLink
                                ? _c(
                                    "el-link",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        "margin-left": "5px"
                                      },
                                      attrs: {
                                        no: "xhqOverseasAgentFeedbackLink"
                                      },
                                      on: {
                                        click:
                                          _vm.xhqShowOverseasAgentFeedbackDialog
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.View")) + " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { label: _vm.$t("SeaExport.BillLadingIssued") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.billLadingIssued,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _vm.OpenXHQDocumentCenter &&
                          (_vm.job.typeHBL === 0 || _vm.job.typeHBL === 1)
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["button_HBL_surrendered"],
                                      expression: "['button_HBL_surrendered']"
                                    }
                                  ],
                                  attrs: {
                                    disabled: _vm.isEdit,
                                    no: "surrendered",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.toSurrendered()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Surrendered"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.lblReleaseState,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: {
                            label: _vm.$t("SeaExport.RequestReleaseState")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value:
                                _vm.form.requestReleaseState === 0
                                  ? _vm.$t("SeaExport.NotApplying")
                                  : _vm.$t("SeaExport.Requested"),
                              disabled: true
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "-85px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.job.jointMasterHBLUuid
                                    ? _vm.$t("SeaExport.TicketHasMerged")
                                    : _vm.job.typeHBL ===
                                      _vm.BillType.SPLIT_BILL_TYPE.code
                                    ? _vm.$t("SeaExport.TicketHasSplit")
                                    : ""
                                )
                              )
                            ]
                          ),
                          _c(
                            "cargo-button-container",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-left": "5px"
                              },
                              attrs: {
                                no: "requestReleaseState",
                                disabled:
                                  _vm.btnBLConfirmDisabled || !_vm.cooperateEdit
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.btnRequestReleasingClickHandler()
                                }
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["button_M/HBL_SingleReleaseHBL"],
                                      expression:
                                        "['button_M/HBL_SingleReleaseHBL']"
                                    }
                                  ],
                                  attrs: {
                                    disabled:
                                      _vm.job.jointMasterHBLUuid ||
                                      _vm.job.typeHBL ===
                                        _vm.BillType.SPLIT_BILL_TYPE.code,
                                    type: "primary"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.form.requestReleaseState === 0
                                          ? _vm.$t("SeaExport.ApplyForARelease")
                                          : _vm.$t(
                                              "SeaExport.WithdrawTheRequestForRelease"
                                            )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "red",
                          attrs: {
                            label: _vm.$t("SeaExport.ReleaseEligibleStatus")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.releaseEligibleLabel,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm.guaranteeConfigEnable
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "red",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.LongTermGuaranteeState"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.SystemConstants.LONG_TERM_GUARANTEE_STATE_MAP.get(
                                    _vm.longTermGuaranteeState
                                  ),
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.guaranteeConfigEnable
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "red",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.SingleTicketGuaranteeState"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_MAP.get(
                                    _vm.singleTicketGuaranteeState
                                  ),
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "6px" },
                              attrs: {
                                value: _vm.form.releaseReview === 1,
                                disabled: true
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DataSent")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "6px" },
                              attrs: { value: _vm.form.payable, disabled: true }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Completed")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-right": "0px" },
                              attrs: {
                                value: _vm.form.withhold,
                                disabled: true
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CargoDetention")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfcompletion") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "agreePayDate",
                              disabled: _vm.isDatePickerDisabled,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.handleDateChange },
                            model: {
                              value: _vm.form.agreePayDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agreePayDate", $$v)
                              },
                              expression: "form.agreePayDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DateOfCargoDetention")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "withholdDate",
                              disabled: true,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.withholdDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "withholdDate", $$v)
                              },
                              expression: "form.withholdDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ParamRemark") } },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.printParam4
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "printParam4",
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                filterable: "",
                                "allow-create": ""
                              },
                              model: {
                                value: _vm.form.printParam4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam4", $$v)
                                },
                                expression: "form.printParam4"
                              }
                            },
                            _vm._l(_vm.pm.printParam4Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                class: _vm.importDifferenceField.printParam4
                                  ? "red-border"
                                  : "",
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.GenerationOfABillOfLading")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.printParam5
                                ? "red-border"
                                : "",
                              attrs: {
                                disabled: _vm.readonly,
                                no: "printParam5",
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                              },
                              model: {
                                value: _vm.form.printParam5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "printParam5", $$v)
                                },
                                expression: "form.printParam5"
                              }
                            },
                            _vm._l(_vm.pm.printParam5Type, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                class: _vm.importDifferenceField.printParam5
                                  ? "red-border"
                                  : "",
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ShippingCompanySCAC")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.txtCarrierScAc, disabled: true }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OverseasAgentSCAC")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.txtBookingAgentScAc,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ShipperContactTelNo")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.shipperTel
                              ? "red-border"
                              : "",
                            attrs: { disabled: _vm.readonly, no: "shipperTel" },
                            model: {
                              value: _vm.form.shipperTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperTel", $$v)
                              },
                              expression: "form.shipperTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ConsigneeContactTelNo")
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.consigneeTel
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "consigneeTel"
                            },
                            model: {
                              value: _vm.form.consigneeTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeTel", $$v)
                              },
                              expression: "form.consigneeTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.NotifyPartyTelNo") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.notifyTel
                              ? "red-border"
                              : "",
                            attrs: { disabled: _vm.readonly, no: "notifyTel" },
                            model: {
                              value: _vm.form.notifyTel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyTel", $$v)
                              },
                              expression: "form.notifyTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CNTRNOSSEALNOS") }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: _vm.readonly,
                                type: "primary"
                              },
                              on: { click: _vm.getPackingInformation }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("SeaExport.GetPackingInformation")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "container",
                              "auto-uppercase": true,
                              type: "textarea",
                              rows: 5,
                              "filter-chars": false
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                                  _vm.form.container,
                                  function(val) {
                                    _vm.form.container = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.container,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "container", $$v)
                              },
                              expression: "form.container"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ReasonOfCargoDetention")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.form.withholdReason,
                              type: "textarea",
                              rows: 5,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_OrderModificationTimes"
                            )
                          }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              precision: 0,
                              min: 0,
                              no: "modificationCount"
                            },
                            model: {
                              value: _vm.form.modificationCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "modificationCount", $$v)
                              },
                              expression: "form.modificationCount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortRequirement")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "portRequirement",
                              type: "textarea",
                              rows: 5
                            },
                            model: {
                              value: _vm.form.portRequirement,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "portRequirement", $$v)
                              },
                              expression: "form.portRequirement"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "line-height": "16px",
                                "margin-top": "5px",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadAttachment(
                                    _vm.form.regionWarehouseMappingUuid
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-paperclip",
                                staticStyle: { "font-size": "16px" }
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "text-decoration": "underline",
                                    color: "blue"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.PortRequirementsRelatedDocuments"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "section" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.freightChargesInfo")))
              ]),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit && _vm.form.uuid,
                          expression: "isEdit&&form.uuid"
                        }
                      ],
                      staticStyle: { padding: "5px 0" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "Add", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showEditDialog(true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "Edit", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showEditDialog(false)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "Delete", type: "danger" },
                          on: { click: _vm.remove }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                      )
                    ],
                    1
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "350px" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.finalRowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  }),
                  _c(
                    "div",
                    { staticStyle: { padding: "5px 0", "font-size": "12px" } },
                    [
                      _c("span", { staticStyle: { color: "#0A0AFF" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.freightChargesUSDTotal"))
                        )
                      ]),
                      _c(
                        "i",
                        {
                          staticStyle: {
                            "margin-left": "15px",
                            "margin-right": "5px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.form.freightChargeEnUpper))]
                      ),
                      _c("i", [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.NumberUtils.formatNumber(
                                _vm.form.freightChargeTotal,
                                2
                              )
                            ) +
                            ")"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                ref: "advanceTextDialogTextarea",
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  "auto-half-word":
                    _vm.advanceTextDialog.formatObj.autoHalfWord,
                  disabled: _vm.readonly
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "confirm", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "close" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: {
              visible: _vm.billAddressDialog.visible,
              job: _vm.job,
              params: _vm.form
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _c("job-no-transcribe-dialog", {
            attrs: {
              visible: _vm.searchBillNoDialog.visible,
              params: _vm.searchBillNoDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
              },
              selected: function(p) {
                _vm.pm.selectionItemHandler(p)
              }
            }
          }),
          _vm.emailInput.visible
            ? _c("email-input", {
                attrs: {
                  visible: _vm.emailInput.visible,
                  context: _vm.context,
                  job: _vm.job,
                  source: "tabHBL",
                  "push-link": _vm.SystemConstants.HBL_INVITATION_STATEMENT,
                  "is-copy-link": true,
                  "job-eamil-data": _vm.jobEamilData,
                  "send-email-data": _vm.emailInput,
                  "send-call-back": _vm.onEmailExecute
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.emailInput, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _c("match-history-dialog", {
            attrs: {
              visible: _vm.matchHistoryDialog.visible,
              "cargo-doc-uuid": _vm.form.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.matchHistoryDialog, "visible", $event)
              }
            }
          }),
          _c("transcribe-dialog", {
            attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.transcribeDialog, "visible", $event)
              },
              callback: _vm.transcribeCallback
            }
          }),
          _c("address-format-dialog", {
            attrs: {
              visible: _vm.addressFormatDialog.visible,
              job: _vm.addressFormatDialog.job,
              params: _vm.addressFormatDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addressFormatDialog, "visible", $event)
              }
            }
          }),
          _vm.batchCheckingWindow.visible
            ? _c("batch-checking-window", {
                attrs: {
                  visible: _vm.batchCheckingWindow.visible,
                  lob: _vm.lob,
                  jobs: _vm.batchCheckingWindow.jobs,
                  "check-node": _vm.batchCheckingWindow.checkNode,
                  "call-back": _vm.batchCheckingWindow.callBack,
                  "call-back2": _vm.batchCheckingWindow.callBack2
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.checkingWindow.visible
            ? _c("checking-window", {
                attrs: {
                  visible: _vm.checkingWindow.visible,
                  lob: _vm.lob,
                  job: _vm.job,
                  "check-node": _vm.checkingWindow.checkNode,
                  "call-back": _vm.checkingWindow.callBack,
                  "call-back2": _vm.checkingWindow.callBack2
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.checkingWindow, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context,
              "pre-print-callback": _vm.prePrintCallback,
              "printed-callback": _vm.printedCallback,
              "v2-check-callback": _vm.v2CheckCallback,
              "return-main-callback": _vm.returnMainCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.editDialog.visible,
                title: _vm.editDialog.title,
                width: "465px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.editDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeItem") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "chargeItemId",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.chargeItemId || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.chargeItemId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeClause") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "paymentTermHBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.paymentTermHBL
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.paymentTermHBL = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Currency") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "currency",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              filterable: "",
                              "default-value": _vm.editDialog.form.currency
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.currency = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "eqSize",
                              "select-type":
                                _vm.selectTypeNames.local_cache_EQSize,
                              headers: [_vm.$t("SeaExport.Code2")],
                              fields: ["code"],
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqSize,
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqSize = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerType") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "eqType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_EQType,
                              headers: [_vm.$t("SeaExport.Code2")],
                              fields: ["code"],
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqType,
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqType = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Quantity2") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "quantity",
                              precision: 0,
                              controls: false
                            },
                            on: {
                              change: function(p) {
                                _vm.caculateAmount()
                                _vm.pm.changeBillOfLadingSynJob()
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "quantity", $$v)
                              },
                              expression: "editDialog.form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "unitRate",
                              precision: 2,
                              controls: false
                            },
                            on: { change: _vm.caculateAmount },
                            model: {
                              value: _vm.editDialog.form.unitRate,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "unitRate", $$v)
                              },
                              expression: "editDialog.form.unitRate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Amount") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "amount",
                              precision: 2,
                              controls: false
                            },
                            on: {
                              change: function($event) {
                                _vm.editDialog.form.unitRate =
                                  _vm.editDialog.form.amount
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "amount", $$v)
                              },
                              expression: "editDialog.form.amount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "save2", type: "primary" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel2" },
                      on: {
                        click: function($event) {
                          _vm.editDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          ),
          _c("cargo-cloud-file-upload", {
            attrs: {
              visible: _vm.cloudFile.visible,
              job: _vm.cloudFile.job,
              lob: _vm.cloudFile.lob,
              "file-size": _vm.cloudFile.fileSize,
              "file-category": _vm.cloudFile.fileCategory,
              "file-category-label": _vm.cloudFile.fileCategoryLabel,
              "upload-source": _vm.cloudFile.uploadSource,
              "other-param": _vm.cloudFile.otherParam
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cloudFile, "visible", $event)
              },
              uploadDone: _vm.onUploadDone
            }
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.checkTheBLLog.visible,
                title: _vm.$t("SeaExport.CheckTheBLCenterApiLog"),
                width: "1000px",
                "close-on-click-modal": false,
                "destroy-on-close": true,
                top: "5vh",
                "custom-class": "details-view settlement-notice"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.checkTheBLLog, "visible", $event)
                }
              }
            },
            [
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid", {
                      attrs: {
                        "grid-params": _vm.checkTheBLLog.gridParams,
                        "grid-options": _vm.checkTheBLLog.gridOptions,
                        "column-defs": _vm.checkTheBLLog.columnDefs,
                        "row-data": _vm.checkTheBLLog.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          return _vm.$set(
                            _vm.checkTheBLLog,
                            "gridParams",
                            $event
                          )
                        },
                        "update:grid-params": function($event) {
                          return _vm.$set(
                            _vm.checkTheBLLog,
                            "gridParams",
                            $event
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("xhq-overseas-agent-feedback-dialog", {
            attrs: {
              visible: _vm.xhqOverseasAgentFeedbackDialog.visible,
              data: _vm.xhqOverseasAgentFeedbackDialog.data,
              callback: _vm.xhqOverseasAgentFeedbackDialog.callback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.xhqOverseasAgentFeedbackDialog,
                  "visible",
                  $event
                )
              }
            }
          }),
          _c("dialog-selector", {
            attrs: {
              visible: _vm.selectorDialog.visible,
              title: _vm.selectorDialog.title,
              "row-data": _vm.selectorDialog.rowData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectorDialog, "visible", $event)
              },
              selected: _vm.getEDICallback
            }
          }),
          _c("message-preview-dialog", {
            attrs: {
              visible: _vm.messagePreviewDialog.visible,
              params: _vm.messagePreviewDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
              },
              uploadSuccess: function(p) {}
            }
          }),
          _c("guarantee-file-dialog", {
            attrs: {
              visible: _vm.guaranteeFileDialog.visible,
              model: _vm.guaranteeFileDialog.model,
              title: _vm.$t("Message.fileManagement")
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.guaranteeFileDialog, "visible", $event)
              },
              saveCallBack: _vm.reloadGuaranteePostHandler
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }